export type BalancedGridColumnCount = 1 | 2 | 3 | 4;

const getGridScore = (itemCount: number, columns: 3 | 4) => {
  const lastRowItems = itemCount % columns || columns;

  return [
    Number(lastRowItems === 1),
    Number(lastRowItems !== columns),
    columns - lastRowItems,
    Math.ceil(itemCount / columns),
  ] as const;
};

/**
 * Selects a compact desktop grid without producing an orphaned final-row item
 * when a three- or four-column arrangement can avoid one.
 */
export const getBalancedGridColumnCount = (itemCount: number): BalancedGridColumnCount => {
  const normalizedCount = Math.max(0, Math.floor(itemCount));

  if (normalizedCount <= 1) return 1;
  if (normalizedCount <= 4) return normalizedCount as BalancedGridColumnCount;

  const threeColumnScore = getGridScore(normalizedCount, 3);
  const fourColumnScore = getGridScore(normalizedCount, 4);

  for (let index = 0; index < threeColumnScore.length; index += 1) {
    if (threeColumnScore[index] !== fourColumnScore[index]) {
      return threeColumnScore[index] < fourColumnScore[index] ? 3 : 4;
    }
  }

  return 4;
};
